module.exports = __webpack_public_path__ + "static/media/arrow-right.fcd6ae69.svg";